import TermsAndConditionsRenderComponent from '../Component';
import type { PdfComponentSectionI } from '../typed';

const TermsAndConditionsRenderSection: React.FunctionComponent<PdfComponentSectionI> =
  function ({ title, content }) {
    return (
      <>
        <span className="text-16-24-em md:text-18-22-em my-1">{title}</span>
        {content.map((component) => (
          <TermsAndConditionsRenderComponent
            key={component.id}
            component={component}
          />
        ))}
      </>
    );
  };

export default TermsAndConditionsRenderSection;
